import { LEPC_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "New York City Portal": {
    parameters: {
      linkUrls: ["https://a826-web01.nyc.gov/T2FilingSystem/Login.aspx"],
      staffInputs: {
        fees: true,
        documentTypes: {
          report: true,
          invoice: true,
          receipt: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.NY.NYC,
          name: "New York City Division of Emergency Response - CRTK",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "NY",
  },
  "Staff - NYC Threshold Review": {
    parameters: {
      staffInputs: {
        fees: false,
        documentTypes: {},
      },
      includeLepcs: [
        {
          id: LEPC_IDS.NY.NYC,
          name: "New York City Division of Emergency Response - CRTK",
        },
      ],
    },
    jurisdictionType: "City/County",
    state: "NY",
  },
};
